module.exports = __webpack_public_path__ + "static/icon-1-e70e2682243e0eedcee7c249c405b50f.png";